const allCategories = [
  'Critical Minerals',
  'Batteries',
  'Sustainability',
  'New Energy',
  'Geopolitics',
]

export default allCategories
